// extracted by mini-css-extract-plugin
module.exports = {"navbarHeight":"70px","loginContainer":"styles_loginContainer__31RM_"};